import React, { useContext, useEffect, useRef } from 'react';

import ReactDOM from 'react-dom';
import { useLocation } from 'react-router-dom';

import { getOverlayElementRoot } from 'common/helpers/domHelpers';

import { DialogContext } from './context';

export default function DialogContainer() {
  const portalContainer = useRef(getOverlayElementRoot('prism-dialog-portal'));

  const { pathname } = useLocation();
  const { closeDialog, component: Component, isOpen, props } = useContext(DialogContext);

  useEffect(() => {
    closeDialog();
  }, [closeDialog, pathname]);

  const children = (Component && <Component {...props} isOpen={isOpen} onClose={closeDialog} />) || null;
  return ReactDOM.createPortal(children, portalContainer.current!);
}
